<form [formGroup]="docsForm">
    <!-- Skills Detail -->
    <div class="profiletitle">
        <!-- <h2 class="title">Documents</h2> -->
        <div class="action" *ngIf="(Id > 0 && Id != null) && !isEditMode">
            <button class=" btn btn-edit btntop" (click)="enableForm()" matTooltip="Edit Details"><i
                    class="fas fa-edit"></i></button>
        </div>
    </div>
    <div class="row row-sm row-documents">
        <div class="col-auto">
            <div class="form-group">
                <label for="docType" class="form-label">Document Type <small class="text-danger fill">*</small></label>              
                <div class="input_wrap">
                    <mat-form-field appearance="outline" class="w-100">
                      <input type="text" id="docType" placeholder="Type/Select" name="docType" matInput
                      formControlName="docType" [matAutocomplete]="auto" (input)="filterDT($event)" [required]="isRequired"
                      [ngClass]="{ 'is-invalid': submitted && docsForm.get('docType')?.errors }">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith"
                    (closed)="onClosedCallback(docType,originalDocType, docsForm, 'docType', 'displayName');onOptionSelectedDT($event);onOptionChange();"
                    (optionSelected)="onSelectionCallback($event, docsForm, 'docType', 'displayName');onOptionSelectedDT($event);onOptionChange();">
                      <mat-option *ngFor="let data of docType; let last = last" [value]="data" [disabled]="isValueDisabled(data.lookUpCode)">
                        {{ data.displayName }}
                      </mat-option>
                      <mat-option *ngIf="docType?.length === 0" disabled  class="no-data-option">
                        Document Type Not Found!
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                    <div *ngIf="submitted && docsForm.get('docType')?.errors" class="invalid-feedbackMt">
                        <div *ngIf="docsForm.get('docType')?.errors?.['required']">Docs Type is required</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto" style="display: none;">
            <div class="form-group">
                <label class="form-label" for="docName">Document name <span class="req">*</span></label>
                <input class="form-control" formControlName="docName" name="docName" placeholder="Enter Doc. Name" maxlength="50"
                    minlength="2" readonly [ngClass]="{ 'is-invalid': submitted &&  docsForm.get('docName')?.errors }">
                <div *ngIf="submitted && docsForm.get('docName')?.errors" class="invalid-feedback">
                    <div *ngIf="docsForm.get('docName')?.errors?.['required']">Document Name is required</div>
                </div>
            </div>
        </div>
        <div class="col-auto" *ngIf="isOtherSel">
          <div class="form-group">
              <label class="form-label" for="docName">Document Information <span class="req">*</span></label>
              <input class="form-control" formControlName="docInfo" name="docInfo" placeholder="Enter Doc. Info" maxlength="50"
                  minlength="2" [ngClass]="{ 'is-invalid': submitted &&  docsForm.get('docInfo')?.errors }" (paste)="handlePaste($event)">
              <div *ngIf="submitted && docsForm.get('docInfo')?.errors" class="invalid-feedback">
                  <div *ngIf="docsForm.get('docInfo')?.errors?.['required']">Document Information is required</div>
                  <div *ngIf="docsForm.get('docInfo')?.errors?.['minlength']">Document Information must be at least a character long.</div>
              </div>
          </div>
      </div>
        <div class="col-auto">
            <div class="form-group">
                <div *ngFor="let docType of documentTypes">
                    <div *ngIf="isVisible(docType)">
                        <label [for]="docType.key" class="form-label" >Upload {{ docType.label}}:</label>
                        <div class="file-upload">
                        <input type="file" [id]="docType.key" formControlName="docFile" [accept]="getAcceptValue(docType.key)" (paste)="handlePaste($event)"
                            (change)="onFileSelected($event, docType.key)"/>
                          </div>
                    </div>
                </div>
                <div *ngIf="!hasVisibleDocType()">
                    <label for="defaultFileType" class="form-label" >Upload</label>
                    <div class="file-upload">
                    <input type="file" id="defaultFileType" formControlName="docFile" accept=".pdf, .doc, .docx" [disabled]="!docsForm.get('docType')?.value"
                    (change)="onFileSelected($event, docType.key)"/>
                  </div>
                </div>
                <div *ngIf="submitted && docsForm.get('docName')?.errors" class="invalid-feedbackMt">
                  <div *ngIf="docsForm.get('docName')?.errors?.['required']">File is required</div>
              </div>
            </div>
        </div>
        <div class="col-auto col-btn">
            <div class="form-group">
                <button type="submit" (click)="saveDocs()" class="btn btn-grey btn-icon-text btn-md"
                    [disabled]="isFormDisabled"><span class="material-symbols-outlined">
                        add
                   </span>Add</button>
            </div>
        </div>
    </div>
    <app-doc-upload-list [data]="getFilteredGridData()" (IsDeleteAction)="handleIsDelete($event)" (deleteItem)="handleDeleteItem($event)"></app-doc-upload-list>
    <div class="button text-right"  [ngClass]="{'blur-section': isFormDisabled}" *ngIf="!saveDocumentOnUpload">
        <button class="btn btn-primary ml-2" *ngIf="!isDeletePopUp" (click)="DocsSubmit()">
            <ng-container *ngIf="(gridData && (gridData[0]?.docsId || gridData[0]?.supDocId) )">
                {{ 'Update' }}
              </ng-container>
              <ng-container *ngIf="(!gridData || !(gridData[0]?.docsId || gridData[0]?.supDocId))">
                {{ 'Save' }}
              </ng-container>
        </button>
    </div>
</form>
